import React from 'react';

const IconArrow: React.FC = (): JSX.Element => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" fill="none" viewBox="0 0 8 14">
            <path style={{stroke: 'var(--secondary-color)'}} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 13l6-5.929L1 1"/>
        </svg>
    );
}

export default IconArrow;